<script setup>
import BudgetTable from '@frontJs/components/tables/projectManagement/customers/BudgetTable.vue';
import ProjectManagementLayout from '@frontJs/layouts/ProjectManagementLayout.vue';
import { Head } from '@inertiajs/vue3';
import TabLayout from '@js/components/tabs/TabLayout.vue';
import PageTitle from '@js/components/titles/PageTitle.vue';
import { h } from 'vue';

defineOptions({ layout: ProjectManagementLayout });
</script>

<template>
    <Head>
        <title>Budgets - Clients - Gestion de projet - Datakepler</title>
    </Head>

    <PageTitle> Gestion de projet - Clients - Budgets </PageTitle>

    <TabLayout
        :tabs="{
            all: {
                title: 'Tous',
                content: h(BudgetTable),
            },
            eCommerce: {
                title: 'E-commerce',
                content: h(BudgetTable, {
                    type: 'e-commerce',
                }),
            },
            showcase: {
                title: 'Vitrine',
                content: h(BudgetTable, {
                    type: 'showcase',
                }),
            },
            marketplace: {
                title: 'Marketplace',
                content: h(BudgetTable, {
                    type: 'marketplace',
                }),
            },
            shop: {
                title: 'Boutique',
                content: h(BudgetTable, {
                    type: 'shop',
                }),
            },
            customMade: {
                title: 'Sur-mesure',
                content: h(BudgetTable, {
                    type: 'custom-made',
                }),
            },
            other: {
                title: 'Autre',
                content: h(BudgetTable, {
                    type: 'other',
                }),
            },
        }"
    />
</template>
